// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2FEdr","notes":"Notes_notes__2kIPK"};